export var GLOBAL = {
		url : 'http://posventa.centromotors.com.co/Backend_GPCM/index.php/'
};